import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const DocumentsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfileDocuments' */ './components/Documents'
		)
);

export default () => ({
	path: 'documents',
	element: <AsyncLoading component={<DocumentsLazy />} />,
});
